// extracted by mini-css-extract-plugin
export default {"featherIcon":"Icons_featherIcon__d7YOz"};